// Виды ИД
export class CdExecutiveDocumentationKinds {
  // Акт освидетельствования скрытых работ
  public static ActOfExaminationOfHiddenWorks: guid = 'f226620d-6c47-4df4-91a0-14a0d8cbdebf';
  // Акт освидетельствования ответственных конструкций
  public static ActOfExaminationOfResponsibleStructures : guid = '88a8dc10-3e0b-4cb0-863e-4f05f4d5a27b';
  // Акт промежуточного освидетельствования ответственных конструкций
  public static ActOfIntermediateExaminationOfResponsibleStructures : guid = 'bd34678c-d265-4681-8ffe-c10feceffd2d';

}